import { render, staticRenderFns } from "./SettingEkp.vue?vue&type=template&id=2af7478f"
import script from "./SettingEkp.vue?vue&type=script&lang=js"
export * from "./SettingEkp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports